import { DataSourceMode, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutHandlingRequirementsCompare } from "./autogen/AutogenLayoutHandlingRequirementsCompare";
import { HandlingRequirementsCompareItem } from "./HandlingRequirementsCompareItem";
import { HandlingRequirementsCompareChangeItem } from "./HandlingRequirementsCompareChangeItem";
import { BaseCompare, TableConfig } from "./BaseCompare";

export class HandlingRequirementsCompare extends AutogenLayoutHandlingRequirementsCompare {
    private _newOrRemovedHandlingRequirements: any[] = [];
    private _changedHandlingRequirements: any[] = [];
    private baseCompare = new BaseCompare();

    // Delegate properties to baseCompare
    get isOrderUpdateAllowed(): boolean { return this.baseCompare.isOrderUpdateAllowed; }
    set isOrderUpdateAllowed(value: boolean) { this.baseCompare.isOrderUpdateAllowed = value; }

    get newOrRemovedHandlingRequirements(): any[] { return this._newOrRemovedHandlingRequirements; }
    set newOrRemovedHandlingRequirements(value: any[]) { this._newOrRemovedHandlingRequirements = value; }

    get changedHandlingRequirements(): any[] { return this._changedHandlingRequirements; }
    set changedHandlingRequirements(value: any[]) { this._changedHandlingRequirements = value; }

    get isInvoice(): boolean { return this.baseCompare.isInvoice; }
    set isInvoice(value: boolean) { this.baseCompare.isInvoice = value; }

    get isCompareHistory(): boolean { return this.baseCompare.isCompareHistory; }
    set isCompareHistory(value: boolean) { this.baseCompare.isCompareHistory = value; }

    setupTableData(mode: DataSourceMode): void {
        const tableConfigs: TableConfig[] = [
            {
                table: this.tableHandlingRequirementAdd,
                label: this.labelAddsAndDeletes,
                data: this.newOrRemovedHandlingRequirements
            },
            {
                table: this.tableHandlingRequirementChange,
                label: this.labelChanges,
                data: this.changedHandlingRequirements
            }
        ];

        this.baseCompare.setupTableData(tableConfigs, mode);
    }

    onHandlingRequirementsAddDeleteRowDisplay(event: TableRowDisplayEvent): void {
        this.baseCompare.handleAddDeleteRowDisplay(
            event,
            this.newOrRemovedHandlingRequirements,
            HandlingRequirementsCompareItem,
            HandlingRequirementsCompareChangeItem
        );
    }

    onHandlingRequirementsChangeRowDisplay(event: TableRowDisplayEvent): void {
        this.baseCompare.handleChangeRowDisplay(
            event,
            this.changedHandlingRequirements,
            HandlingRequirementsCompareItem,
            HandlingRequirementsCompareChangeItem
        );
    }
}